<template>
  <div class="row">
    <div class="col-md-6">
      <table>
        <tbody class="vuetable-body">
          <tr v-if="isAdmin">
            <td><b> {{ 'Joint ID' | translate }} </b></td>
            <td> {{ rowData.joint_id }} </td>
          </tr>
          <tr v-if="isAdmin">
            <td><b> {{ 'Revision' | translate }} </b></td>
            <td> {{ rowData.rev }} </td>
          </tr>
          <tr>
            <td><b> {{ 'Machine ID' | translate }} </b></td>
            <td> {{ rowData.name }} </td>
          </tr>
          <tr v-if="rowData.skarv_id">
            <td><b> {{ 'Skarv-ID' | translate }} </b></td>
            <td> {{ rowData.skarv_id }} </td>
          </tr>
          <tr v-if="0">
            <td><b> {{ 'stored' | translate }} </b></td>
            <td> {{ rowData.stored }} </td>
          </tr>
          <tr>
            <td><b> {{ 'dimension' | translate }} </b></td>
            <td> {{ rowData.dimension }} </td>
          </tr>
          <tr>
            <td><b> {{ 'timestamp' | translate }} </b></td>
            <td> {{ rowData.datetime }} </td>
          </tr>
          <tr>
            <td><b> {{ 'u_mains' | translate }} </b></td>
            <td> {{ rowData.u_mains }} </td>
          </tr>
          <tr v-if="rowData.u_mains_min || rowData.u_mains_max">
            <td><b> {{ 'u_mains_min_max' | translate }} </b></td>
            <td> {{ rowData.u_mains_min }} / {{ rowData.u_mains_max }} </td>
          </tr>
          <tr>
            <td><b> {{ 'mode' | translate }} </b></td>
            <td> {{ rowData.mode }} </td>
          </tr>
          <tr>
            <td><b> {{ 'channel' | translate }} </b></td>
            <td> {{ rowData.channel }} </td>
          </tr>
          <tr>
            <td><b> {{ 'alarm' | translate }} </b></td>
            <td> {{ 'ALARM-' + rowData.alarm | translate }} </td>
          </tr>
          <tr>
            <td><b> {{ 'processDone' | translate }} </b></td>
            <td> {{ rowData.weld_status | translate }} </td>
          </tr>
          <tr v-if="0">
            <td><b> {{ 'temps' | translate }} </b></td>
            <td> {{ rowData.temps.filter(Boolean).join(', ') }}</td>
          </tr>
          <tr>
            <td><b> {{ 'joint_time_a' | translate }} </b></td>
            <td> {{ calcJointTime(rowData.joint_time_a) }} </td>
          </tr>
          <tr v-if="rowData.comment">
            <td><b> {{ 'Comment' | translate }} </b></td>
            <td> {{ rowData.comment }} </td>
          </tr>

        </tbody>
      </table>
    </div>
    <div class="col-md-6">
        <template v-if="!(rowData.mode == 1 && rowData.dimension < 280)">
          <temp-curve-chart class="chart-wrapper" :chartData="prepDataset(rowData.temps)" style="height:300px;margin-top:40px;" height="300"></temp-curve-chart>
        </template>
        <div v-if="rowData.latitude < 9999" class="mt-3">
          <detail-map :joint="rowData"></detail-map>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TempCurveChart from '../components/TempCurveChart'
import JointMixin from '../mixins/JointMixin'
import { convertNmeaToDecimal } from '../utils/coordinates'

var DetailMap = {
  props: ['joint'],
  template: '<div ref="mapEl" style="height:200px;width:100%;z-index:1;"></div>',
  mounted: function () {
    var Lmod = require('leaflet')
    var L = Lmod.default || Lmod
    require('leaflet/dist/leaflet.css')
    var lat = convertNmeaToDecimal(this.joint.latitude)
    var lng = convertNmeaToDecimal(this.joint.longitude)
    var map = L.map(this.$refs.mapEl, {
      center: [lat, lng],
      zoom: 14,
      zoomControl: true,
      attributionControl: false
    })
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18
    }).addTo(map)
    L.circleMarker([lat, lng], {
      radius: 8,
      fillColor: '#007bff',
      color: '#fff',
      weight: 2,
      fillOpacity: 0.9
    }).addTo(map)
    this._map = map
  },
  beforeDestroy: function () {
    if (this._map) {
      this._map.remove()
    }
  }
}

export default {
  components: {
    TempCurveChart,
    DetailMap
  },
  mixins: [JointMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    isAdmin: function () {
      return this.currentUser.role.indexOf('admin') >= 0
    }
  },
  data: () => {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// JointDetailRow.vue?82461e36